import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/useAuth';
import { GuardApi } from '@/lib/guard-api';
import { queryKeys } from '@/config/query-keys';

const STALE_TIME = 1000 * 60 * 5;

export function usePinCodes() {
  const { selectedCustomer } = useAuth();
  const customerId = selectedCustomer?.customerId;

  return useQuery({
    queryKey: queryKeys.guard.pinCodes(customerId ?? 0),
    queryFn: () => GuardApi.getPinCodes(),
    staleTime: STALE_TIME,
    enabled: customerId != null,
  });
}
